<template>
  <div class="app-loading-container">
    <div class="background-animation" aria-hidden="true">
      <span class="bubble"></span>
      <span class="bubble"></span>
      <span class="bubble"></span>
    </div>
    <div class="app-loading-wrp">
      <div class="app-loading-img-cdp">
        <img class="w-100" src="/cdp_logo.png" draggable="false" alt="logo" />
        <span class="app-loader"></span>
      </div>
      <div class="app-loading-img-choco">
        <img class="w-100" src="/choco_powerby.png" draggable="false" alt="loading" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.app-loading-container {
  position: relative;
  width: 100%;
  height: 100vh;
  padding: 28vh 0 2vh 0;
  overflow: hidden;

  .background-animation {
    position: absolute;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
    z-index: 0;
    contain: layout style paint;

    .bubble {
      position: absolute;
      width: 200px;
      height: 200px;
      border-radius: 50%;
      filter: blur(0.5px);
      background: radial-gradient(circle at 30% 30%, rgba(255, 255, 255, 0.9), rgba(0, 134, 255, 0.35));
      opacity: 0.5;
      will-change: transform, opacity;
      animation: appLoadingBubbleFloat 30s linear infinite;

      &:nth-child(1) {
        top: -40px;
        left: -30px;
        animation-duration: 32s;
      }

      &:nth-child(2) {
        bottom: 10%;
        right: 8%;
        width: 240px;
        height: 240px;
        animation-duration: 38s;
        animation-delay: 3s;
      }

      &:nth-child(3) {
        bottom: -60px;
        left: 15%;
        width: 150px;
        height: 150px;
        animation-duration: 26s;
        animation-delay: 6s;
      }
    }
  }

  .app-loading-wrp {
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    height: 100%;

    .app-loading-img-cdp {
      width: 15vmin;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .app-loading-img-choco {
      width: 200px;
    }

    .app-loader {
      width: 48px;
      height: 48px;
      border: 4px solid #0086ff;
      border-bottom-color: transparent;
      border-radius: 50%;
      display: inline-block;
      box-sizing: border-box;
      animation: rotation 0.7s linear infinite;
      margin-top: 5rem;
    }

    @keyframes rotation {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
}

@keyframes appLoadingBubbleFloat {
  0% {
    transform: translate3d(0, 0, 0) scale(1);
    opacity: 0.5;
  }

  12.5% {
    transform: translate3d(10px, -15px, 0) scale(1.02);
    opacity: 0.53;
  }

  25% {
    transform: translate3d(18px, -28px, 0) scale(1.05);
    opacity: 0.56;
  }

  37.5% {
    transform: translate3d(8px, -44px, 0) scale(1.02);
    opacity: 0.58;
  }

  50% {
    transform: translate3d(-14px, -56px, 0) scale(0.98);
    opacity: 0.6;
  }

  62.5% {
    transform: translate3d(-8px, -44px, 0) scale(1.01);
    opacity: 0.58;
  }

  75% {
    transform: translate3d(9px, -28px, 0) scale(1.04);
    opacity: 0.56;
  }

  87.5% {
    transform: translate3d(5px, -13px, 0) scale(1.02);
    opacity: 0.53;
  }

  100% {
    transform: translate3d(0, 0, 0) scale(1);
    opacity: 0.5;
  }
}

@media (prefers-reduced-motion: reduce) {
  .app-loading-container .background-animation .bubble {
    animation: none;
  }
}
</style>
